import { objectToCamelCase } from '../utils'

import NotificationAPI from './api'

export default class Notification {
  static api = NotificationAPI.create(Notification)

  constructor(json) {
    Object.assign(this, { ...json })
  }

  static create(opts) {
    return new Notification(opts)
  }

  static fromAPI(json) {
    return new Notification(objectToCamelCase(json))
  }
}